import React from 'react';
import {observer} from 'mobx-react';
import _ from 'lodash';
import Button from '../../common/Button';
import store from '../../../store/SparePartsFinderFiltersBasketStore';
import SPFFiltersCart from './cart/SPFFiltersCart';
import SparePartsFinderIndexPage from '../SparePartsFinderIndexPage';
import SparePartsFinderFilterPanel from './SparePartsFinderFilterPanel';
import SparePartsFinderFiltersIndexTable from './SparePartsFinderFiltersIndexTable';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import SparePartsFinderFiltersApiService from '@lib/api-services/SparePartsFinderFiltersApiService';

const IndexPage = observer(
    class SparePartsFinderFiltersIndexPage extends SparePartsFinderIndexPage {

        static defaultProps = {
            tableComponentClass: SparePartsFinderFiltersIndexTable,
            indexTablePagerVisible: false
        }

        constructor(props) {
            super(props);
            this.filtersPanel = React.createRef();
        }

        renderFilterPanel = () => (
            <React.Fragment>
                {this.renderBasket()}
                <SparePartsFinderFilterPanel
                    ref={this.filtersPanel}
                    filters={this.state.filter.viewFilters}
                    onFilterChange={this.onFilterChange}
                    onFiltersChange={this.onFiltersChange}
                />
            </React.Fragment>
        )

        renderBasket() {
            var market = this.state.filter.viewFilters.find(x => x.meta.slug === 'Market');
            if (!store.basketIsOpen) {
                return (
                    <React.Fragment/>
                )
            }

            return (
                <SPFFiltersCart market={market.model}/>
            )
        }

        onRowCheckboxToggledPost = () => {
            var request = this.buildIndexAPIRequestModel();
            var service = APIServicesRegistry.getService(SparePartsFinderFiltersApiService);
            this.setState({
                isLoading: true
            });

            service.getPriceSummary({
                ...request,
                selectedIds: this.getSelectedRowIds()
            }).then(response => {
                this.setState({
                    priceSummary: response.data,
                    isLoading: false
                })
            })
        }

        renderFooterActionButtons() {
            return (
                <Button
                    theme={Button.Theme.BorderOnly}
                    disabled={this.getSelectedRowIds().length === 0}
                    onClick={this.onAddSelectedToBasketClick}
                >
                    {__('Add selected to basket')}
                </Button>
            )
        }

        onAddSelectedToBasketClick = () => {
            const ids = this.getSelectedRowIds();
            store.addToBasketIfNotExistsMany(ids.map(x => Number(x)));
        }
    }
)

export default IndexPage;